import React, { useRef, useEffect } from 'react';

const ClickOutsideDetector = ({ children, onClickOutside }) => {
  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      onClickOutside();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return <div ref={containerRef}>{children}</div>;
};

export default ClickOutsideDetector;
